<template>
    <div class="stringcheck" :data-processing="processing">
        <div v-for="string in instance.strings" :key="string.name" class="stringcheck__wrap">
            <div v-if="answerContainsString(string.name) || string.always_show === 'yes'" class="stringcheck__response affirmation__response__then" :class="string.is_correct">
                <h3 class="stringcheck__response__name type--h3--default" v-text="string.name">{{ string.name }}</h3>
                <div class="stringcheck__response__explaination type--content-styles type--content-margins type--content-links" v-html="string.explaination"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                processing: this.instance.type !== "empty" ? true : false,
                type: this.instance.type === undefined ? "ifthen" : this.instance.type,
            }
        },
        computed: {
            answer() {
                return this.siloData.user.modules[this.instance.check_field] ? this.siloData.user.modules[this.instance.check_field] : null;
            },
            isEmpty() {
                return this.answer.length > 0 ? false : true;
            },
            isAnswerThis() {

                // If this is an array, compare it against the first item in the array
                if (Array.isArray(this.answer)) {
                    return this.answer[0] === this.instance.if_equals_text ? true : false;
                // Otherwise, just compare it against the string
                } else {
                    return this.answer === this.instance.if_equals_text ? true : false;
                }
            },
        },
        props: {
            siloData: Object,
            instance: Object,
            active: Boolean,
        },
        watch: {
            siloData: {
                handler() {
                    this.processing = true;
                },
                immediate: true,
            },
        },
        methods: {
            answerContainsString(string) {
                return this.answer !== null && this.answer.includes(string) ? true : false;
            },
        }
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.stringcheck {
    display: flex;
    flex-direction: column;
    gap: rem(21px);
}

.stringcheck__wrap {

}

.stringcheck__response {
    display: flex;
    flex-direction: column;
    gap: rem(8px);
}

.stringcheck__response__name {

}

.stringcheck__response__explaination {

}

</style>